import { create } from 'zustand';

export const useStore = create((set) => ({
    loading: false,
    setLoading: (loading) =>
        set((state) => ({
            ...state,
            loading,
        })),
    accessToken: null,
    setAccessToken: (accessToken) =>
        set((state) => ({
            ...state,
            accessToken,
        })),
    refreshToken: null,
    setRefreshToken: (refreshToken) =>
        set((state) => ({
            ...state,
            refreshToken,
        })),
    phone: '',
    setPhone: (phone) =>
        set((state) => ({
            ...state,
            phone,
        })),
    email: null,
    setEmail: (email) =>
        set((state) => ({
            ...state,
            email,
        })),
    permissions: [],
    setPermissions: (permissions) =>
        set((state) => ({
            ...state,
            permissions,
        })),
    profile: [],
    setProfile: (profile) =>
        set((state) => ({
            ...state,
            profile,
        })),
    formError: null,
    setFormError: (formError) =>
        set((state) => ({
            ...state,
            formError,
        })),
    successMessage: null,
    setSuccessMessage: (successMessage) =>
        set((state) => ({
            ...state,
            successMessage,
        })),
    title: '',
    setTitle: (title) =>
        set((state) => ({
            ...state,
            title,
        })),
    countries: [],
    setCountries: (countries) => set((state) => ({ ...state, countries })),
    members: [],
    setMembers: (members) => set((state) => ({ ...state, members })),
    kitTypes: [],
    setKitTypes: (kitTypes) => set((state) => ({ ...state, kitTypes })),
    kitTypeCategories: [],
    setKitTypeCategories: (kitTypeCategories) =>
        set((state) => ({ ...state, kitTypeCategories })),
    isLoading: false,
    setIsLoading: (isLoading) =>
        set((state) => ({
            ...state,
            isLoading,
        })),
    isInitialized: false,
    setInitialized: (val) => set({ isInitialized: val }),
    userId: null,
    setUserId: (userId) =>
        set((state) => ({
            ...state,
            userId,
        })),
    userInstitution: null,
    setUserInstitution: (userInstitution) =>
        set((state) => ({
            ...state,
            userInstitution,
        })),
    userPhone: null,
    setUserPhone: (userPhone) =>
        set((state) => ({
            ...state,
            userPhone,
        })),
    userEmail: null,
    setUserEmail: (userEmail) =>
        set((state) => ({
            ...state,
            userEmail,
        })),
    defaultAvatars: [],
    setDefaultAvatars: (defaultAvatars) =>
        set((state) => ({
            ...state,
            defaultAvatars,
        })),
}));

export default useStore;
